import type { ReactNode } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardBody } from '@vnetwork/ui/primitives';

/** Shared dashboard widget shell — card + header (title/description + actions). */
export function WidgetCard({
  title,
  description,
  actions,
  bodyPadding = true,
  children,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  bodyPadding?: boolean;
  children: ReactNode;
}) {
  return (
    <Card flat style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader actions={actions}>
        <CardTitle>{title}</CardTitle>
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>
      {bodyPadding ? <CardBody style={{ flex: 1 }}>{children}</CardBody> : <CardBody style={{ padding: 0, flex: 1 }}>{children}</CardBody>}
    </Card>
  );
}
